/* Provider is a component that can pass stores (or other stuff) using React's context mechanism to child components. This is useful if you have things that you don't want to pass through multiple layers of components explicitly. */
import { Provider } from 'mobx-react';
// react code
import React from 'react';
// import strict mode for mobx
import { configure } from 'mobx';
// code, to connect react components to the DOM
import { render } from 'react-dom';
// Sentry API Log
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// import mobx stores and function to call all bootstrap functions in individual stores
import stores, { bootstrapStores } from '~/common/stores/stores.js';

// import our application
import App from './App.js';
// import root error handler for app-wide fallback UI
import ErrorBoundary from './ErrorBoundary.js';

// Initiate Sentry only in Prod
if (ENV === 'production') {
    Sentry.init({
        dsn: 'https://655d2f5d97ed4bbdb75c877daa160a00@o173976.ingest.sentry.io/4504339240648704',
        integrations: [new BrowserTracing()],
        maxBreadcrumbs: 50,
        environment: 'production',
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0
    });
}

// Mobx state can't be changed outside of an action
configure({ enforceActions: 'always' });

if (ENV !== 'production' && module.hot) module.hot.accept();

// get element, in index.html file, that will be used to rendered our app
const app = document.getElementById('app');

// call the constructor-like functions for each store
bootstrapStores();

render(
    <ErrorBoundary sendErrorsToLog={ENV === 'production'}>
        <Provider {...stores}>
            <App />
        </Provider>
    </ErrorBoundary>
    , app
);

